/**
 * 1.4.1 시스템 설정 Store
 *
 * @since 2017-12-12
 * @author devp020
 */
export const state = () => ({
  // api url 목록
  apiUrl: {
    // 시스템 정보
    systemInfoUrl: '/api/sm/system-info',
    // 호스트명 정보
    hostnameInfoUrl: '/api/sm/hostname',
    // 시스템 시간 정보
    timeInfoUrl: '/api/sm/time',
    // NTP 서버 설정 정보
    ntpServerUrl: '/api/sm/ntp-server',
    // NTP 동기화 정보
    ntpSyncUrl: '/api/sm/ntp-sync',
    // SSH 접속포트 설정 정보
    sshPortUrl: '/api/sm/ssh-port',
    // HTTPS 접속포트 설정 정보
    httpsPortUrl: '/api/sm/https-port',
    // 시스템 시간
    systemTime: '/api/sm/info/time',
    // Docker 인터페이스 정보 조회
    dockerUrl: '/api/sm/local-network'
  },
  systemInfo: {},
  hostnameInfo: {},
  hostnameResult: null,
  timeInfoResult: null,
  ntpSyncResult: null,
  ntpServerResult: null,
  sshPortInfo: {},
  orgSshPortInfo: {},
  sshPortResult: null,
  httpsPortInfo: {},
  orgHttpsPortInfo: {},
  httpsPortResult: null,
  sysTimeSet: {
    type: '',
    now_clock: '',
    ntp: {
      svr1: '',
      svr2: '',
      interval: 0,
      mode: 2 // 1: slew, 2: step -> ui에서 제거됨, 2: step 고정값으로 요청
    },
    tz_type: 1,
    tz_data: {
      offset_hour: 0,
      offset_minute: 0,
      offset_second: 0,
      offset_sign: '+',
      zone: 'Asia/Seoul'
    },
    tz_list: []
  },
  systemTimeResult: null,
  timezoneList: [],
  timezoneOffset: {
    offset_hour: 0,
    offset_minute: 0,
    offset_second: 0,
    offset_sign: '+',
    zone: 'Asia/Seoul'
  },
  dockerInfo: {
    docker_internal_ip: null,
    docker_gwbridge_ip: null
  }
})

export const mutations = {
  mutInitStore (state) {
    state.systemInfo = {}
    state.hostnameInfo = {}
    state.sshPortInfo = {}
    state.orgSshPortInfo = {}
    state.httpsPortInfo = {}
    state.orgHttpsPortInfo = {}
    state.sysTimeSet = {
      type: '',
      now_clock: '',
      ntp: {
        svr1: '',
        svr2: '',
        interval: 0,
        mode: 2
      },
      tz_type: 1,
      tz_data: {
        offset_hour: 0,
        offset_minute: 0,
        offset_second: 0,
        offset_sign: '+',
        zone: 'Asia/Seoul'
      },
      tz_list: []
    }
    state.timezoneList = []
    state.timezoneOffset = {
      offset_hour: 0,
      offset_minute: 0,
      offset_second: 0,
      offset_sign: '+',
      zone: 'Asia/Seoul'
    }
  },
  // 시스템 정보 조회
  mutSystemInfo (state, payload) {
    state.systemInfo = payload
  },
  // 호스트명 정보 조회
  mutHostnameInfo (state, payload) {
    state.hostnameInfo = payload
  },
  // 호스트명 정보 수정
  mutPutHostnameInfo (state, payload) {
    state.hostnameInfo.hostname = payload
  },
  // 시스템 시간 정보 수정
  mutPutTimeInfo (state, payload) {
    state.timeInfoResult = payload
  },
  // NTP 동기화 정보 수정
  mutPutNtpSyncInfo (state, payload) {
    state.ntpSyncResult = payload
  },
  // NTP 서버 설정 정보 수정
  mutPutNtpServerInfo (state, payload) {
    state.ntpServerResult = payload
  },
  // 시스템 시간 정보 조회
  mutGetSystemTimeInfo (state, payload) {
    state.sysTimeSet = payload
    state.timezoneOffset = payload.tz_data
    state.timezoneList = []
    for (const tz of payload.tz_list) {
      state.timezoneList.push(
        {
          label: tz.comment,
          value: tz.timezone
        }
      )
    }
  },
  // 시스템 시간 정보 수정
  mutSetSystemTimeInfo (state, payload) {
    state.systemTimeResult = payload
  },
  // SSH 접속 포트 설정 정보 조회
  mutSshPortInfo (state, payload) {
    state.sshPortInfo = payload
    state.orgSshPortInfo.ssh_port = state.sshPortInfo.ssh_port
  },
  // SSH 접속 포트 설정 정보 수정
  mutPutSshPortInfo (state, payload) {
    state.sshPortResult = payload
  },
  // HTTPS 접속 포트 설정 정보 조회
  mutHttpsPortInfo (state, payload) {
    state.httpsPortInfo = payload
    state.orgHttpsPortInfo.port = state.httpsPortInfo.port
  },
  // HTTPS 접속 포트 설정 정보 수정
  mutPutHttpsPortInfo (state, payload) {
    state.httpsPortResult = payload
  },
  mutDockerInfo (state, payload) {
    state.dockerInfo = payload
  },
  resetStore (state) {
    state.systemInfo = {}
    state.hostnameInfo = {}
    state.hostnameResult = null
    state.timeInfoResult = null
    state.ntpSyncResult = null
    state.ntpServerResult = null
    state.sshPortInfo = {}
    state.orgSshPortInfo = {}
    state.sshPortResult = null
    state.httpsPortInfo = {}
    state.orgHttpsPortInfo = {}
    state.httpsPortResult = null
    state.sysTimeSet = {
      type: '',
      now_clock: '',
      ntp: {
        svr1: '',
        svr2: '',
        interval: 0,
        mode: 2
      },
      tz_type: 1,
      tz_data: {
        offset_hour: 0,
        offset_minute: 0,
        offset_second: 0,
        offset_sign: '+',
        zone: 'Asia/Seoul'
      },
      tz_list: []
    }
    state.systemTimeResult = null
    state.timezoneList = []
    state.timezoneOffset = {
      offset_hour: 0,
      offset_minute: 0,
      offset_second: 0,
      offset_sign: '+',
      zone: 'Asia/Seoul'
    }
    state.dockerInfo = {
      docker_internal_ip: null,
      docker_gwbridge_ip: null
    }
  }
}

export const actions = {
  // 시스템 정보 조회
  async acsSystemInfo ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.apiUrl.systemInfoUrl}`, {loading: false, successAlert: false})
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutSystemInfo', data.result)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 호스트명 정보 조회
  async acsHostnameInfo ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.apiUrl.hostnameInfoUrl}`, {loading: false, successAlert: false})
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutHostnameInfo', data.result)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 호스트명 정보 수정
  async acsPutHostnameInfo ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.apiUrl.hostnameInfoUrl}`, payload)
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // NTP 서버 설정 정보 조회
  async getSystemTimeInfo ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.apiUrl.systemTime}`, {loading: false, successAlert: false})
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutGetSystemTimeInfo', data.result)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // NTP 서버 설정 정보 수정
  async setSystemTimeInfo ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.apiUrl.systemTime}`, payload, {successAlert: false})
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutSetSystemTimeInfo', data.result)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // SSH 접속 포트 정보 조회
  async acsSshPortInfo ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.apiUrl.sshPortUrl}`, {loading: false, successAlert: false})
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutSshPortInfo', data.result)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // SSH 접속 포트 정보 수정
  async acsPutSshPortInfo ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.apiUrl.sshPortUrl}`, payload)
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutPutSshPortInfo', data)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // HTTPS 접속 포트 정보 조회
  async acsHttpsPortInfo ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.apiUrl.httpsPortUrl}`, {loading: false, successAlert: false})
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutHttpsPortInfo', data.result)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // HTTPS 접속 포트 정보 수정
  async acsPutHttpsPortInfo ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.apiUrl.httpsPortUrl}`, payload, {successAlert: false})
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutPutHttpsPortInfo', data)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // Docker 정보 조회
  async acsGetDockerInfo ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.apiUrl.dockerUrl}`, {loading: false, successAlert: false})

      if (_.isNil(data)) {
        return {code: 'nok', errors: null}
      }

      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutDockerInfo', data.result)
      return {code: 'ok'}
    } catch (e) {
      return {code: 'error', errors: e}
    }
  }
}

export const getters = {
}

export const strict = false
